import { Answer, Question, QuestionnaireService } from "@/types/questionnaire";
import { useState } from "react";
import QuestionRadio from "./QuestionRadio";
import QuestionCheckboxComponent from "./QuestionCheckbox";

interface Properties {
    answer: Answer,
    setSubAnswerCompleted: (_: boolean) => void,
}

function SubAnswer(properties: Properties): JSX.Element {
    const {answer, setSubAnswerCompleted} = {...properties};
    const subQuestions: Question[] = QuestionnaireService.AnswerGetSubQuestions(answer);
    
    const [subQuestionsCompleted, initialCompleted] = (() => {
        let completed: number = 0;
        let initialCompleted: boolean[] = new Array(subQuestions.length);
        for(const index in subQuestions) {
            initialCompleted[index] = QuestionnaireService.QuestionIsCompleted(subQuestions[index]);
            completed += initialCompleted[index] ? 1 : 0;
        }
        return [completed, initialCompleted];
    })();    

    const [totalSubQuestionsCompleted, setTotalSubQuestionsCompleted] = useState<number>(subQuestionsCompleted);
    const [subQuestionCompletionState, setSubQuestionCompletionState] = useState<boolean[]>(initialCompleted);
    
    const setSubQuestionCompleted = function(index: number, completed: boolean) {
        if( subQuestionCompletionState[index] == completed ) return;

        const newValues: boolean[] = [...subQuestionCompletionState];
        newValues[index] = completed;
        const newCompletionTotal: number = totalSubQuestionsCompleted + (completed ? 1 : -1);
        setSubQuestionCompletionState(newValues);
        setTotalSubQuestionsCompleted(newCompletionTotal);

        if( newCompletionTotal >= subQuestions.length ) {
            setSubAnswerCompleted(true);
        } else {
            setSubAnswerCompleted(false);
        }
    }

    return <>
        { subQuestions.map((question: Question, index: number) => {
            const callback = setSubQuestionCompleted.bind(null, index);
            if( question.type === "switch" ) {
                return <QuestionRadio key={question.id} question={question} setQuestionCompleted={callback}/>
            } else {
                return <QuestionCheckboxComponent key={question.id} question={question} description="" setQuestionCompleted={callback}/>
            }
        })}
    </>
}

export default SubAnswer;